<template>
  <div class="manual_infor" v-wechat-title="'身份认证'">
    <div class="content">
      <div class="form-list">
        <div>
          <span>商户名称</span>
          <input v-model.trim="form.idCardName" placeholder="请输入商户名称" @keyup="handleMobileNumKeyUp" />
          <div v-show="form.idCardName" @click="handleClearMobileNumClick('idCardName')">
            <img :src="require('@/assets/clear.png')" alt />
          </div>
        </div>
        <div>
          <span>法人身份证</span>
          <input v-model.trim="form.idCardNum" placeholder="请输入法人身份证" @keyup="handleMobileNumKeyUp" />
          <div v-show="form.idCardNum" @click="handleClearMobileNumClick('idCardNum')">
            <img :src="require('@/assets/clear.png')" alt />
          </div>
        </div>
        <div>
          <span>有效期限</span>
          <input class="pick" @click="openData('pickerstart')" v-model.trim="form.dateOfIssue" readonly placeholder="发证日期" />
          -
          <input class="pick invalid" @click="openData('pickerend')" v-model.trim="form.dateOfInvalid" placeholder="失效日期" readonly />
        </div>
        <div>
          <span>经营地址</span>
          <input v-model.trim="form.businessAddress" placeholder="请填写经营地址" @keyup="handleMobileNumKeyUp" />
          <div v-show="form.businessAddress" @click="handleClearMobileNumClick('businessAddress')">
            <img :src="require('@/assets/clear.png')" alt />
          </div>
        </div>
      </div>
      <div class="button-list">
        <mt-button type="primary" size="large" @click="handleBtnClick">提交</mt-button>
      </div>
      <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value}" month-format="{value}" date-format="{value}"></mt-datetime-picker>
    </div>
  </div>
</template>

<script>
/* global wx */

import { formatDateId, formatDate } from '@/utils/utils.js';
import { GetIdNameFaceServiceUrl } from '@/api/interface';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'ManualBankInfor',
  data() {
    return {
      form: {
        idCardNum: '',
        idCardName: '',
        businessAddress: '',
        isAddHoldIDCard: 0,
        holdIsMust: 1,
        dateOfIssue: '',
        dateOfInvalid: '',
      },
      start: '',
      end: '',
      picker: {
        startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 50)),
        endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 50)),
      },
      currentDateType: '',
    };
  },
  methods: {
    handleClearMobileNumClick(data) {
      this.form[data] = '';
    },
    handleMobileNumKeyUp() {},
    openData(data) {
      if (this.form.dateOfInvalid && data === 'pickerstart') {
        this.picker.endDate = new Date(this.end);
        this.picker.startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 50));
      }

      if (this.form.dateOfIssue && data === 'pickerend') {
        this.picker.startDate = new Date(this.start);
        this.picker.endDate = new Date(new Date().setFullYear(new Date().getFullYear() + 50));
      }

      this.currentDateType = data;

      this.$refs.picker.open();
    },
    handleConfirm(value) {
      if (this.currentDateType === 'pickerstart') {
        this.form.dateOfIssue = formatDateId(value);
        this.start = formatDate(value);
      } else {
        this.form.dateOfInvalid = formatDateId(value);
        this.end = formatDate(value);
      }
    },

    // 提交前验证
    validateVal() {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!this.form.idCardName) {
        CusToast('商户名称不能为空');
        return 'err';
      }
      if (!this.form.idCardNum) {
        CusToast('身份证号码不能为空');
        return 'err';
      }
      if (!reg.test(this.form.idCardNum)) {
        CusToast('身份证格式不正确');
        return 'err';
      }
      if (!this.form.dateOfIssue) {
        CusToast('请选择发证日期');
        return 'err';
      }
      if (!this.form.dateOfInvalid) {
        CusToast('请选择失效日期');
        return 'err';
      }
      if (!this.form.businessAddress) {
        CusToast('经营地址不能为空');
        return 'err';
      }
      return 'ok';
    },
    handleBtnClick() {
      if (this.validateVal() === 'ok') {
        const data = {
          idCardNum: this.form.idCardNum,
          idCardName: this.form.idCardName,
          dateOfIssue: this.form.dateOfIssue,
          dateOfInvalid: this.form.dateOfInvalid,
          isAddHoldIDCard: 0,
          holdIsMust: 1,
          businessAddress: this.form.businessAddress,
        };
        GetIdNameFaceServiceUrl(data)
          .then(res => {
            const msg = SucceedHandle(res.code, res.msg, () => {
              res.data.Msg && CusToast(res.data.Msg);
              wx.miniProgram.redirectTo({
                url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.form.idCardName}&flowName=认证流程`,
              });
            });
            msg && CusToast(msg);
          })
          .catch(err => {
            const msg = NotSucceedHandle(err.message);
            msg && CusToast(msg);
            CusToast(err.msg);
          });
      }
    },
  },
};
</script>
